/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberSavingAccountInputDto { 
    memberId: number;
    savingProductId: number;
    periodType?: string | null;
    tenure?: number | null;
    interestRate?: number | null;
    openingBalance?: number | null;
    useAttachedAccountForInterestPayout?: boolean | null;
    debitAccountId?: number | null;
    creditAccountId?: number | null;
    fdMaturityConfigurationId?: number | null;
}

